import { SET_CREDIT_SUBMISSIONS } from './types';

const initialState = {};

export const creditSubmissionReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CREDIT_SUBMISSIONS:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
